var graph5 = function() {

  const getCellValue = (tr, idx) => tr.children[idx].innerText || tr.children[idx].textContent;

  const comparer = (idx, asc) => (a, b) => ((v1, v2) => {
      if (v1.includes("%")) {
        v1 = parseInt( v1.slice(0, -1) );
        v2 = parseInt( v2.slice(0, -1) );
      } else {}

      return v1 !== '' && v2 !== '' && !isNaN(v1) && !isNaN(v2) ? v1 - v2 : v1.toString().localeCompare(v2)
    })(getCellValue(asc ? a : b, idx), getCellValue(asc ? b : a, idx));


  const runSort = function(chosenTh){
    const table = chosenTh.closest('table');
    Array.from(table.querySelectorAll('tr:nth-child(n+2)'))
        .sort(comparer(Array.from(chosenTh.parentNode.children).indexOf(chosenTh), this.asc = !this.asc))
        .forEach(tr => table.appendChild(tr) );
  };

  document.querySelectorAll('#graph5_table1 th').forEach(th => th.addEventListener('click', () => runSort(th) ));
  document.querySelectorAll('#graph5_table2 th').forEach(th => th.addEventListener('click', () => runSort(th) ));

}

module.exports = graph5;
